<template>
  <v-dialog v-model="dialog" persistent max-width="500" style="z-index:99;" scrollable transition="dialog-bottom-transition" :overlay="false">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title :class="`${arabic?'arFont':'enFont'}`">اجابات للفرض - Hausaufgabe</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click.native="close()" :class="`${arabic?'arFont':'enFont'}`">اغلاق</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-row class="align-center"> 
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
            <v-text-field
              label="العنوان"
              outlined
              hide-details
              dense
              v-model="resource.title"
              :class="`${arabic?'arFont':'enFont'}`"
            ></v-text-field>
          </v-col>
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
            <v-textarea
              label="وصف او تفاصيل"
              outlined
              hide-details
              dense
              v-model="resource.text"
              :class="`${arabic?'arFont':'enFont'}`"
            ></v-textarea>
          </v-col>
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.urls && resource.urls.length">
            <v-row row justify-center NEWATTACHMENTDIALOG>
              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" v-for="(url, u) in resource.urls" :key="'url-'+u">
                <v-btn block :loading="loading" :disabled="loading" text color="success" :class="`${arabic?'arFont':'enFont'}`" @click="openLink(url)">عرض الملف {{u+1}}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
            <v-row row justify-center NEWATTACHMENTDIALOG>
              <v-dialog v-model="newAttachmentDialog" persistent max-width="500">
                <v-card :loading="loading">
                  <v-toolbar dark color="primary">
                    <v-btn icon @click.native="newAttachmentDialog = false" dark>
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title :class="`${arabic?'arFont':'enFont'}`">تحميل ملف</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click.native="newAttachmentDialog = false" :class="`${arabic?'arFont':'enFont'}`">اغلاق</v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <v-row class="pa-0">
                      <v-col cols="12" class="py-1">
                        <v-row row justify-center class="py-0" v-if="resource.urls && resource.urls.length">
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0`" v-for="(attachment, u) in resource.urls" :key="'attachment-'+u">
                            <v-btn block :loading="loading" :disabled="loading" text small color="success" :class="`${arabic?'arFont':'enFont'}`" @click="openLink(attachment.url)">عرض الملف {{u+1}}</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="py-1">
                        <v-btn color="success" @click.native="pickFileImages()" :loading="uploadProgress" :class="`${arabic?'arFont':'enFont'}`"
                          >اختيار ملف
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click.native="()=>{
                      newAttachmentDialog = false;
                    }" :loading="loading" :class="`${arabic?'arFont':'enFont'}`"
                      >تأكيد
                    </v-btn>
                    <v-btn color="error" text @click.native="()=>{
                      newAttachmentDialog = false;
                      resource.url = null
                    }" :loading="loading" :class="`${arabic?'arFont':'enFont'}`"
                      >الغاء
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            
            <v-btn block :loading="loading" :disabled="loading" color="success" :class="`${arabic?'arFont':'enFont'}`" @click="()=>{
              newAttachmentDialog = true
            }">تحميل ملف</v-btn>
            <input
              type="file"
              style="display: none"
              ref="fileImages"
              accept="csv/*"
              @change="onFilePickedImages"
            >
          </v-col>
          
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :class="`${arabic?'arFont':'enFont'}`" @click="postResource()" :disabled="!resource.text || !resource.title">
          اضافة اجابة جديدة
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { firebase, store, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {},
  props:['dialog'],
  data(){
    return {
      resource:{},
      uploadProgress:null,
      file:null,
      loading:false,
      newAttachmentDialog:false,
    }
  },
  methods: {
    close() {
      this.$emit('closeDialog')
    },
    postResource(){
      this.$emit('postResource', this.resource)
    },
    openLink(url) {
      window.open(url, '_blank');
    },
    pickFileImages(){
      this.$refs.fileImages.click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('submission/A_R_A_M_C_C_O_' + randomString(16, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = false
          if(!this.resource.urls) {
            this.resource.urls = []
          }
          this.resource.urls.push(downloadURL)
          console.log(downloadURL)
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } 
    },
  },
  watch:{
    
  },
  computed:{
    progress(){
      return (this.visible + this.prev_progress)/69 * 100
    },
    questions(){
      return this.quiz
    },
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x&&x.roles.includes(role))
          }
        } else if(x&&x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x&&x.roles.includes(role))
      return this.$store.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  mounted(){
  },
  created(){
  }
}
</script>
